export class RequestError extends Error {}
